import { api } from '../../../services/api/client';
import type { LiveSession } from '../../../types';

export interface SessionPayload {
  title: string;
  description?: string;
  session_type?: 'public' | 'member' | 'vip';
  mentor_id?: string | null;
  meeting_url?: string;
  starts_at?: string;
  ends_at?: string;
  status?: 'scheduled' | 'ongoing' | 'completed' | 'cancelled';
  is_published?: boolean;
}

// Member
export async function fetchMemberSessions(): Promise<LiveSession[]> {
  const { data } = await api.get<LiveSession[]>('/member/live-trades');
  return data;
}
export async function fetchMemberSession(id: string): Promise<LiveSession> {
  const { data } = await api.get<LiveSession>(`/member/live-trades/${id}`);
  return data;
}

// Admin
export async function adminFetchSessions(): Promise<LiveSession[]> {
  const { data } = await api.get<LiveSession[]>('/admin/live-trades');
  return data;
}
export async function adminCreateSession(payload: SessionPayload): Promise<LiveSession> {
  const { data } = await api.post<LiveSession>('/admin/live-trades', payload);
  return data;
}
export async function adminUpdateSession(id: string, payload: Partial<SessionPayload>): Promise<LiveSession> {
  const { data } = await api.put<LiveSession>(`/admin/live-trades/${id}`, payload);
  return data;
}
export async function adminDeleteSession(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/live-trades/${id}`);
  return data;
}

// Mentor
export async function mentorFetchSessions(): Promise<LiveSession[]> {
  const { data } = await api.get<LiveSession[]>('/mentor/live-trades');
  return data;
}
export async function mentorCreateSession(payload: SessionPayload): Promise<LiveSession> {
  const { data } = await api.post<LiveSession>('/mentor/live-trades', payload);
  return data;
}
export async function mentorUpdateSession(id: string, payload: Partial<SessionPayload>): Promise<LiveSession> {
  const { data } = await api.put<LiveSession>(`/mentor/live-trades/${id}`, payload);
  return data;
}

export function toInputValue(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function toIso(input?: string): string {
  if (!input) return '';
  const d = new Date(input);
  return isNaN(d.getTime()) ? '' : d.toISOString();
}
export function fmtRange(startIso?: string, endIso?: string): string {
  const s = startIso ? new Date(startIso) : null;
  const e = endIso ? new Date(endIso) : null;
  if (!s) return '—';
  const opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
  const st = s.toLocaleString('id-ID', opts);
  const et = e ? e.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) : '';
  return et ? `${st} – ${et}` : st;
}
